import React from 'react';
const _ = {
    map: require('lodash/map'),
};

const TextStylerToolbar = require('@muzzylane/react-mzl/dist/TextStylerToolbar');
const RichText = require('@muzzylane/react-mzl/dist/RichText');

import ShortCoursePlayStore from '../../../stores/ShortCoursePlayStore';

// this is also knownn as the "Report Card" in design documentation
function CriteriaScores({skillsInvolved,latestAssessmentAttemptData,node_gate,criteriaScoresStyle,reportPhase,app,richText}) {
    const textStyle=TextStylerToolbar.makeStyle(criteriaScoresStyle||{});
    
    // default behavior (show checks, nothing empathised)
    let showChecks = true;
    let showHeart = latestAssessmentAttemptData.activityTypeObj.gate && node_gate && latestAssessmentAttemptData.activityTypeObj.gate < node_gate;
    let passedClass = "skill-line"; // "skill-line passed" (passed = old criteria scores behavior)
    let failedClass = "skill-line"; // "skill-line failed" (failed = old criteria scores behavior)
    const addEmp = " with-emphasis";
    const addGreyOut = " grey-out";
    
    switch(reportPhase) {
        case ShortCoursePlayStore.REPORT_CARD_PHASE.START: // Nothing checked. Nothing emphasized or greyed out.
            showChecks = false;
            showHeart = false;
            break;
        case ShortCoursePlayStore.REPORT_CARD_PHASE.HIGHLIGHT_PASSED: // Passed skills are emphasized and checked. Failed skills are greyed out
            passedClass += addEmp;
            failedClass += addGreyOut;
            break;
        case ShortCoursePlayStore.REPORT_CARD_PHASE.HIGHLIGHT_FAILED: // Passed skills are greyed out and checked. Failed skills are emphasized. 
            passedClass += addGreyOut;
            failedClass += addEmp;
            break;
        case ShortCoursePlayStore.REPORT_CARD_PHASE.END: // Passed skills are checked. Nothing is emphasized. 
            break;
    }
    
    return (
        <div className="skill-section" style={textStyle}>
            <h3>{'Criteria'}</h3>
            {showHeart ?
                <div className="star-wrapper completed">
                    <img src={`${GlobalConfig.StaticUrl}/img/courses/completed_star.svg`} aria-hidden />
                </div>
            :   <div className="star-wrapper">
                    <img src={`${GlobalConfig.StaticUrl}/img/courses/active_star.svg`} aria-hidden />
                </div>
            }
            { _.map(skillsInvolved,(sk,i)=>(
                <div key={i} className={sk.passed ? passedClass : failedClass}>
                    <div className="skill-checkbox" style={{"--animation-order": i + 1}}>
                        <input id={"cs-checkbox-" + i} type="checkbox" checked={sk.passed && showChecks} readOnly aria-hidden/>
                        <label htmlFor={"cs-checkbox-" + i} className="check-box" />
                    </div>
                    {/*<span className="score-value">{`${Math.round(sk.score)}%`}</span>*/}
                    <span className="skill-name">{sk.subskill.display_name}</span>
                </div>
            ))}
            { (app && richText) ? 
            <RichText app={app} richText={richText} /> 
            : null }
        </div>
    );
};

export default CriteriaScores;